import { HStack, Text, VStack } from '@chakra-ui/react';
import { Switch } from '@components/ui/switch';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectActiveUser } from '@redux/authent/authent.selectors';
import { selectHeightSuffix } from '@redux/settings/settings.selectors';
import { usePatchHeightSuffixMutation } from '@services/config/setting.api';
import { FormattedMessage } from 'react-intl';

export default function MiscellaneousSettings() {
  const { login } = useAppSelector(selectActiveUser);
  const heightSuffix = useAppSelector(selectHeightSuffix);

  const [patchHeightSuffix, { isLoading }] = usePatchHeightSuffixMutation();

  const handleHeightSuffix = () => {
    patchHeightSuffix({
      login,
      heightSuffix: !heightSuffix,
    });
  };

  return (
    <VStack width="100%" height="100%" backgroundColor="neutral.800" gap={4} padding={4} alignItems="start">
      <Text fontSize="22px">
        <FormattedMessage id="components.userSettings.miscellaneous.title" />
      </Text>
      <HStack width="100%" gap={2}>
        <Switch disabled={isLoading} checked={heightSuffix} onCheckedChange={handleHeightSuffix} />
        <Text textStyle="md">
          <FormattedMessage id="components.userSettings.miscellaneous.heightSuffix" />
        </Text>
      </HStack>
    </VStack>
  );
}
